/* Blackwater Theme — global JS
   - Sticky bar reveal on scroll + dismiss
   - Exit-intent / time-delay popup
   - Mobile menu toggle
   - Newsletter / contact form AJAX feedback
   ========================================================= */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initCleanGlyphs();
    initMobileMenu();
    initStickyBar();
    initExitPopup();
    initAllProductsCarousel();
    initFormAjax();
    initReviewsTabs();
    initProductStickyPdp();
  });

  /** Remove decorative ★ / → from visible UI copy (theme editor may still store them). */
  function initCleanGlyphs() {
    var re = /[\u2605\u2606\u2B50\u2190-\u2193\u2196-\u2199]/g;
    var sel =
      '.eyebrow, .bfw-badge, a.btn, button.btn, .mobile-cta, .tile-product .btn, ' +
      '#bw-sticky button, #bw-popup button, .press-bar-label, .press-label';
    $$(sel).forEach(function (el) {
      if (!el || el.closest('[data-preserve-glyphs]')) return;
      var t = (el.textContent || '').replace(re, '').replace(/\s+/g, ' ').trim();
      if (t) el.textContent = t;
    });
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function initMobileMenu() {
    var toggle = $('[data-nav-toggle]');
    var menu = $('[data-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function pageShowStickyBar() {
    var opts = document.getElementById('bw-page-display');
    if (!opts) return true;
    return opts.getAttribute('data-sticky-bar') !== 'false';
  }

  function initStickyBar() {
    if (!pageShowStickyBar()) return;
    var sticky = document.getElementById('bw-sticky');
    if (!sticky) return;
    var threshold = parseFloat(sticky.getAttribute('data-scroll-threshold') || '0.12');
    var dismissed = sessionStorage.getItem('bw_sb_dismissed');
    if (!dismissed) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > document.body.scrollHeight * threshold) {
          sticky.classList.add('visible');
        }
      }, { passive: true });
    }
    var closeBtn = sticky.querySelector('.sb-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        sticky.classList.remove('visible');
        sessionStorage.setItem('bw_sb_dismissed', '1');
      });
    }
  }

  function initExitPopup() {
    var overlay = document.getElementById('bw-popup-overlay');
    if (!overlay) return;
    var delay = parseInt(overlay.getAttribute('data-delay') || '25000', 10);
    var shown = sessionStorage.getItem('bw_pop_shown');
    var popClose = overlay.querySelector('.pop-close');

    function openPopup() {
      if (sessionStorage.getItem('bw_pop_shown')) return;
      overlay.classList.add('open');
      sessionStorage.setItem('bw_pop_shown', '1');
    }

    if (!shown) {
      setTimeout(openPopup, delay);
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY < 10) openPopup();
      });
    }

    if (popClose) {
      popClose.addEventListener('click', function () {
        overlay.classList.remove('open');
      });
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.classList.remove('open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') overlay.classList.remove('open');
    });
  }

  function initFormAjax() {
    var wraps = $$('[data-ajax-form-wrap]');
    var forms = [];
    wraps.forEach(function (wrap) {
      var f = wrap.querySelector('form');
      if (f) forms.push(f);
    });
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type=email]');
        if (emailInput && !emailInput.value) return;

        var topicSelect = form.querySelector('[data-contact-topic]');
        var messageField = form.querySelector('#bw-contact-message, textarea[name="contact[body]"]');
        if (topicSelect && messageField) {
          if (!topicSelect.value) return;
          var topicLine = 'Topic: ' + topicSelect.value;
          var body = (messageField.value || '').trim();
          messageField.value = topicLine + (body ? '\n\n' + body : '');
        }

        // Merge any checked [data-bw-interest] checkboxes into the contact[tags] hidden field
        // so they land as tags on the Shopify customer record (filterable in admin).
        var tagsField = form.querySelector('input[name="contact[tags]"]');
        if (tagsField) {
          var baseTags = tagsField.value
            .split(',')
            .map(function (t) { return t.trim(); })
            .filter(Boolean);
          var checked = $$('[data-bw-interest]:checked', form).map(function (cb) {
            return cb.value.trim();
          }).filter(Boolean);
          tagsField.value = baseTags.concat(checked).join(',');
        }

        var fd = new FormData(form);
        var endpoint = form.getAttribute('action') || '/contact';

        fetch(endpoint, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'text/html' }
        }).then(function (res) {
          if (!res.ok) {
            console.warn('[Blackwater] Form submit returned HTTP ' + res.status, form.id);
          } else {
            console.info('[Blackwater] Form submit OK (' + res.status + ')', form.id, 'tags=', tagsField ? tagsField.value : '(none)');
          }
        }).catch(function (err) {
          console.error('[Blackwater] Form submit network error', form.id, err);
        }).finally(function () {
          var container = form.closest('[data-ajax-form-wrap]') || form.parentNode;
          form.style.display = 'none';
          var label = container.querySelector('[data-ajax-form-label]');
          if (label) label.style.display = 'none';
          var success = container.querySelector('[data-ajax-form-success]') ||
                        form.parentNode.querySelector('.sb-success, .pop-success, .contact-page-success');
          if (success) {
            success.hidden = false;
            success.classList.add('is-visible');
            success.style.display = 'block';
          }
          var sticky = form.closest('#bw-sticky');
          if (sticky) {
            sessionStorage.setItem('bw_sb_dismissed', '1');
            setTimeout(function () { sticky.classList.remove('visible'); }, 3000);
          }
          var popOverlay = form.closest('#bw-popup-overlay');
          if (popOverlay) {
            setTimeout(function () { popOverlay.classList.remove('open'); }, 3000);
          }
        });
      });
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatWithDelimiters(cents, 2);
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function initProductStickyPdp() {
    var root = $('[data-product-sticky-pdp]');
    if (!root) return;

    var jsonEl = root.querySelector('[data-pdp-product-json]');
    if (!jsonEl) return;

    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.warn('[Blackwater] PDP product JSON parse failed', e);
      return;
    }

    var variants = data.variants || [];
    var mediaList = data.media || [];
    var selectEl = root.querySelector('[data-pdp-variant-select]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var compareEl = root.querySelector('[data-pdp-compare]');
    var submitEl = root.querySelector('[data-pdp-submit]');
    var mainWrap = root.querySelector('[data-pdp-main-media]');
    var thumbs = $$('[data-pdp-thumb]', root);
    var optionGroups = $$('[data-option-index]', root);
    var optionButtons = $$('[data-pdp-option-btn]', root);

    function getVariantById(id) {
      return variants.find(function (v) { return String(v.id) === String(id); });
    }

    function findVariantByOptions(opts) {
      return variants.find(function (v) {
        var match = true;
        if (opts[0] != null && v.option1 !== opts[0]) match = false;
        if (opts[1] != null && v.option2 !== opts[1]) match = false;
        if (opts[2] != null && v.option3 !== opts[2]) match = false;
        return match;
      });
    }

    function getSelectedOptions() {
      var opts = [null, null, null];
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var selected = group.querySelector('.pdp-variant-btn.is-selected');
        if (selected) opts[idx] = selected.getAttribute('data-option-value');
      });
      return opts;
    }

    function syncOptionButtons(variant) {
      if (!variant || !optionButtons.length) return;
      var vals = [variant.option1, variant.option2, variant.option3];
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var val = vals[idx];
        $$('.pdp-variant-btn', group).forEach(function (btn) {
          var isSel = btn.getAttribute('data-option-value') === val;
          btn.classList.toggle('is-selected', isSel);
        });
      });
    }

    function setActiveThumb(mediaId) {
      thumbs.forEach(function (thumb) {
        var active = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function showMedia(mediaId) {
      var media = mediaList.find(function (m) { return String(m.id) === String(mediaId); });
      if (!media || !mainWrap) return;

      setActiveThumb(mediaId);

      if (media.media_type === 'image' && media.src) {
        var img = mainWrap.querySelector('.pdp-main-img');
        if (!img || img.tagName !== 'IMG') {
          mainWrap.innerHTML = '<img class="product-photo pdp-main-img" data-media-id="' + media.id + '" alt="">';
          img = mainWrap.querySelector('.pdp-main-img');
        }
        img.src = media.src;
        img.alt = media.alt || data.title || '';
        img.setAttribute('data-media-id', media.id);
        if (img.removeAttribute) img.removeAttribute('srcset');
      }
    }

    function mediaIdForVariant(variant) {
      if (!variant) return null;
      if (variant.featured_media_id) return variant.featured_media_id;
      return mediaList.length ? mediaList[0].id : null;
    }

    function updateVariant(variant, options) {
      if (!variant) return;

      if (selectEl) {
        if (selectEl.tagName === 'SELECT') {
          selectEl.value = String(variant.id);
        } else {
          selectEl.value = String(variant.id);
        }
      }

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price, data.moneyFormat);
      }

      if (compareEl && data.showComparePrice) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.classList.toggle('is-hidden', !onSale);
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price, data.moneyFormat) : '';
      }

      if (submitEl) {
        submitEl.disabled = !variant.available;
        submitEl.textContent = variant.available ? data.addToCartText : data.soldOutText;
      }

      syncOptionButtons(variant);

      var mid = mediaIdForVariant(variant);
      if (mid) showMedia(mid);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function onVariantIdChange(id) {
      var variant = getVariantById(id);
      if (variant) updateVariant(variant);
    }

    if (selectEl && selectEl.tagName === 'SELECT') {
      selectEl.addEventListener('change', function () {
        onVariantIdChange(selectEl.value);
      });
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        if (!group) return;
        $$('.pdp-variant-btn', group).forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        var variant = findVariantByOptions(getSelectedOptions());
        if (variant) updateVariant(variant);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        var src = thumb.getAttribute('data-src');
        if (src) {
          showMedia(id);
        } else {
          setActiveThumb(id);
        }
      });
    });

    var params = new URLSearchParams(window.location.search);
    var variantParam = params.get('variant');
    var initialId = (selectEl && selectEl.value) || (variants[0] && variants[0].id);
    if (variantParam) initialId = variantParam;
    onVariantIdChange(initialId);
  }

  function initAllProductsCarousel() {
    $$('[data-all-products-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('.all-products-track');
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      if (!track) return;

      function scrollBySlide(direction) {
        var slide = track.querySelector('.all-products-slide');
        if (!slide) return;
        var gap = 22;
        var step = slide.getBoundingClientRect().width + gap;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollBySlide(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollBySlide(1);
        });
      }
    });
  }

  function initReviewsTabs() {
    var wraps = $$('[data-reviews-tabs]');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var tabs = $$('.reviews-tab', wrap);
      var panels = $$('.reviews-panel', wrap);
      if (!tabs.length || !panels.length) return;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-target');
          tabs.forEach(function (t) {
            var isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.id === target);
          });
        });
      });
    });
  }
})();
